var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonHeartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_93140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_93140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add",
    d: "M12.1667 16.2222C10.7 16.2222 9.48148 15.737 8.5111 14.7667C7.54074 13.7963 7.05557 12.5778 7.05557 11.1111C7.05557 9.64443 7.54074 8.42592 8.5111 7.45557C9.48148 6.48519 10.7 6 12.1667 6C13.6333 6 14.8519 6.48519 15.8222 7.45557C16.7926 8.42592 17.2778 9.64443 17.2778 11.1111C17.2778 12.5778 16.7926 13.7963 15.8222 14.7667C14.8519 15.737 13.6333 16.2222 12.1667 16.2222ZM1.5 26.9111V23.5778C1.5 22.8074 1.69444 22.1056 2.08333 21.4722C2.47222 20.8389 3.01852 20.363 3.72223 20.0444C5.29261 19.3259 6.74697 18.8093 8.0853 18.4944C9.42366 18.1796 10.7829 18.0222 12.1631 18.0222C13.5432 18.0222 14.9 18.1796 16.2333 18.4944C17.5667 18.8093 19.0185 19.3259 20.5889 20.0444C21.2926 20.3778 21.8426 20.8574 22.2389 21.4833C22.6352 22.1093 22.8333 22.8074 22.8333 23.5778V26.9111H1.5ZM3.7222 24.6889H20.6111V23.5778C20.6111 23.2593 20.5241 22.9593 20.35 22.6778C20.1759 22.3963 19.9445 22.1852 19.6556 22.0444C18.2037 21.3555 16.9111 20.8833 15.7778 20.6278C14.6444 20.3722 13.4407 20.2444 12.1667 20.2444C10.8926 20.2444 9.68519 20.3722 8.54443 20.6278C7.4037 20.8833 6.10741 21.3555 4.65557 22.0444C4.36666 22.1852 4.13887 22.3963 3.9722 22.6778C3.80553 22.9593 3.7222 23.2593 3.7222 23.5778V24.6889ZM12.1667 14C12.9889 14 13.6759 13.7241 14.2278 13.1722C14.7796 12.6204 15.0556 11.9333 15.0556 11.1111C15.0556 10.2889 14.7796 9.60184 14.2278 9.05C13.6759 8.49813 12.9889 8.2222 12.1667 8.2222C11.3444 8.2222 10.6574 8.49813 10.1056 9.05C9.5537 9.60184 9.27777 10.2889 9.27777 11.1111C9.27777 11.9333 9.5537 12.6204 10.1056 13.1722C10.6574 13.7241 11.3444 14 12.1667 14Z",
    fill: "#054BC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "volunteer_activism",
    d: "M23.8975 18C23.3178 17.4783 22.7619 16.9679 22.2298 16.4689C21.6977 15.97 21.2301 15.4826 20.8269 15.0069C20.4237 14.5311 20.1018 14.0706 19.8611 13.6254C19.6204 13.1801 19.5 12.7501 19.5 12.3354C19.5 11.6749 19.7245 11.1205 20.1735 10.6723C20.6226 10.2241 21.1779 10 21.8396 10C22.2178 10 22.587 10.0963 22.9472 10.2888C23.3075 10.4814 23.6242 10.7412 23.8975 11.0683C24.1708 10.7412 24.4876 10.4814 24.8478 10.2888C25.2081 10.0963 25.5773 10 25.9554 10C26.6171 10 27.1725 10.2241 27.6215 10.6723C28.0705 11.1205 28.295 11.6749 28.295 12.3354C28.295 12.7501 28.1747 13.1801 27.934 13.6254C27.6933 14.0706 27.3713 14.5311 26.9681 15.0069C26.5649 15.4826 26.0976 15.9707 25.5661 16.4711C25.0347 16.9714 24.4785 17.4811 23.8975 18Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonHeartBlue);
export default __webpack_public_path__ + "static/media/person-heart-blue.7b1548c5f4bbfe29633e1d081b946eb4.svg";
export { ForwardRef as ReactComponent };